import { forwardRef, InputHTMLAttributes } from "react";
import {
  StyledToggleSwitchContainer,
  StyledToggleSwitchInput,
  StyledToggleSwitchSlider,
} from "./ToggleSwitch.styled";

interface ToggleSwitchProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
> {
  onChange?: (value: boolean) => void;
  value?: boolean;
}

const ToggleSwitch = forwardRef<HTMLInputElement, ToggleSwitchProps>(
  ({ onChange, value, ...props }, ref) => {
    return (
      <StyledToggleSwitchContainer>
        <StyledToggleSwitchInput
          ref={ref}
          type="checkbox"
          checked={value}
          onChange={(e) => {
            if (!props.disabled && onChange) {
              onChange(e.target.checked);
            }
          }}
          {...props}
        />
        <StyledToggleSwitchSlider disabled={props.disabled} />
      </StyledToggleSwitchContainer>
    );
  },
);

export default ToggleSwitch;
